import { Editor, EditorState } from 'draft-js';
import * as React from 'react';
import { draftFromHtml } from '../../../utils/messagingHelpers';

interface Props {
    htmlString: string;
}

export default function DisplayHTML({ htmlString }: Props) {
    const [editorState, setEditorState] = React.useState<EditorState>(draftFromHtml(htmlString));

    React.useEffect(() => {
        /*
            TIP: In some cases (ApEditor) htmlString data is not available until after the first
            render (data mapped in useEffect).

            Update when received, otherwise will always show empty.
         */
        setEditorState(draftFromHtml(htmlString));
    }, [htmlString]);

    return <Editor onChange={setEditorState} editorState={editorState} readOnly />;
}
